<template>
    <v-menu offset-y left :min-width="minWidth" :close-on-content-click="true">
        <template v-slot:activator="{ on, attrs }">
            <v-btn v-if="iconOnly" icon :small="small" :aria-label="label" v-bind="attrs" v-on="on" @click.stop>
                <v-icon size="20">{{ icon || "mdi-dots-horizontal" }}</v-icon>
            </v-btn>
            <v-btn v-else outlined :small="small" :disabled="disabled" v-bind="attrs" v-on="on" @click.stop>
                <v-icon v-if="icon" left small>{{ icon }}</v-icon>
                {{ label }}
                <v-icon right small>mdi-chevron-down</v-icon>
            </v-btn>
        </template>
        <v-list dense class="ui-action-menu">
            <template v-for="(item, index) in visibleItems">
                <v-divider v-if="item.divider" :key="`d-${index}`" class="my-1"></v-divider>
                <v-subheader v-else-if="item.header" :key="`h-${index}`" class="ui-action-menu__header">{{ item.header }}</v-subheader>
                <v-list-item v-else :key="`i-${index}`" :to="item.to" :disabled="item.disabled || item.loading" :id="item.id"
                    @click="item.handler && item.handler()">
                    <v-list-item-icon v-if="hasIcons" class="mr-3">
                        <v-progress-circular v-if="item.loading" indeterminate size="16" width="2"></v-progress-circular>
                        <v-icon v-else size="18" :color="item.danger && !item.disabled ? '#dc2626' : undefined">{{ item.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title :class="{ 'ui-action-menu__danger': item.danger && !item.disabled }">{{ item.text }}</v-list-item-title>
                        <v-list-item-subtitle v-if="item.description">{{ item.description }}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </template>
        </v-list>
    </v-menu>
</template>

<script>
// Botao com menu de acoes (DropdownMenu do shadcn) para juntar acoes
// secundarias. items: [{ text, icon?, handler?, to?, id?, disabled?, hidden?,
// loading?, danger?, description? } | { divider: true } | { header: "Titulo" }].
// Divisores/titulos sobrando (no inicio, no fim ou repetidos) sao omitidos.
export default {
    name: "UiActionMenu",
    props: {
        items: { type: Array, required: true },
        label: { type: String, default: "Mais ações" },
        icon: { type: String, default: null },
        iconOnly: { type: Boolean, default: false },
        small: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false },
        minWidth: { type: [Number, String], default: 220 },
    },
    computed: {
        visibleItems() {
            const items = this.items.filter((item) => !item.hidden);
            // remove titulo sem itens abaixo e divisores nas pontas/duplicados
            const cleaned = items.filter((item, index) => {
                const next = items[index + 1];
                if (item.header) return next && !next.header && !next.divider;
                if (item.divider) return index > 0 && next && !next.divider;
                return true;
            });
            while (cleaned.length && cleaned[cleaned.length - 1].divider) cleaned.pop();
            return cleaned;
        },
        hasIcons() {
            return this.visibleItems.some((item) => item.icon);
        },
    },
};
</script>
